import { render, staticRenderFns } from "./Pos_supplier_edit.vue?vue&type=template&id=6bf4dcf6&scoped=true&"
import script from "./Pos_supplier_edit.vue?vue&type=script&lang=js&"
export * from "./Pos_supplier_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4dcf6",
  null
  
)

export default component.exports